import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../../helpers/tapCountMutation";

function ReviewCardBasic({ preview, color }) {
    const [cardData] = useContext(CardContext)
    const { review } = cardData
    const HColor = color ? color : 'black'

    /* ------------------ tap count taking using tanstack query ----------------- */

    const queryClient = useQueryClient();

    const handleTap = (button, id) => {
        // console.log("iiii", id);

        updateTapCount(queryClient, button, id);
    };

    return (
        <>

            {review?.map((reviewData) =>
                reviewData.reviewName ? (
                    <Link
                        onClick={() => handleTap('reviews', reviewData._id)}
                        to={`${preview ? reviewData?.reviewUrl : ""}`}
                        target={`${preview ? "_blank" : ""}`}
                    >
                        {/* <div className="flex gap-3 mt-2 p-[16px] justify-between"> */}
                        {/* <div className="flex gap-3"> */}

                        <div className="flex justicy-center items-center gap-2">
                            <svg
                                width="30"
                                height="30"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M24.9374 32.9297C25.1122 33.1039 25.2509 33.3109 25.3455 33.5388C25.4401 33.7667 25.4889 34.011 25.4889 34.2578C25.4889 34.5046 25.4401 34.7489 25.3455 34.9768C25.2509 35.2048 25.1122 35.4117 24.9374 35.5859L24.0093 36.5141C22.2505 38.2728 19.8652 39.2608 17.378 39.2608C14.8908 39.2608 12.5055 38.2728 10.7468 36.5141C8.98804 34.7553 8 32.37 8 29.8828C8 27.3956 8.98804 25.0103 10.7468 23.2516L14.5155 19.4844C16.2053 17.7904 18.4789 16.8066 20.8705 16.7346C23.2622 16.6625 25.5908 17.5077 27.3796 19.0969C27.5642 19.261 27.7148 19.4599 27.8226 19.6823C27.9304 19.9046 27.9933 20.146 28.0078 20.3926C28.0223 20.6393 27.9881 20.8864 27.9071 21.1198C27.8261 21.3533 27.7 21.5684 27.5358 21.7531C27.3717 21.9378 27.1727 22.0883 26.9504 22.1961C26.7281 22.3039 26.4867 22.3669 26.24 22.3814C25.9934 22.3959 25.7463 22.3617 25.5129 22.2807C25.2794 22.1997 25.0642 22.0735 24.8796 21.9094C23.8069 20.9568 22.4109 20.45 20.9769 20.4927C19.543 20.5354 18.1796 21.1243 17.1655 22.1391L13.3999 25.9016C12.3448 26.9566 11.7521 28.3876 11.7521 29.8797C11.7521 31.3718 12.3448 32.8027 13.3999 33.8578C14.4549 34.9129 15.8859 35.5056 17.378 35.5056C18.8701 35.5056 20.3011 34.9129 21.3561 33.8578L22.2843 32.9297C22.4584 32.7554 22.6652 32.6171 22.8928 32.5227C23.1204 32.4283 23.3644 32.3798 23.6108 32.3798C23.8572 32.3798 24.1012 32.4283 24.3288 32.5227C24.5564 32.6171 24.7632 32.7554 24.9374 32.9297ZM36.5124 10.7422C34.7522 8.98617 32.3674 8 29.8811 8C27.3948 8 25.01 8.98617 23.2499 10.7422L22.3218 11.6703C21.9695 12.0225 21.7716 12.5003 21.7716 12.9984C21.7716 13.4966 21.9695 13.9743 22.3218 14.3266C22.674 14.6788 23.1517 14.8767 23.6499 14.8767C24.148 14.8767 24.6258 14.6788 24.978 14.3266L25.9061 13.3984C26.9612 12.3434 28.3922 11.7506 29.8843 11.7506C31.3763 11.7506 32.8073 12.3434 33.8624 13.3984C34.9174 14.4535 35.5102 15.8845 35.5102 17.3766C35.5102 18.8686 34.9174 20.2996 33.8624 21.3547L30.0952 25.1234C29.0803 26.1378 27.716 26.7259 26.2817 26.7674C24.8474 26.8089 23.4515 26.3008 22.3796 25.3469C22.1949 25.1827 21.9797 25.0565 21.7463 24.9756C21.5128 24.8946 21.2657 24.8604 21.0191 24.8749C20.7724 24.8894 20.531 24.9523 20.3087 25.0601C20.0864 25.1679 19.8875 25.3184 19.7233 25.5031C19.5592 25.6878 19.433 25.903 19.352 26.1364C19.271 26.3699 19.2368 26.6169 19.2513 26.8636C19.2658 27.1103 19.3288 27.3516 19.4366 27.574C19.5444 27.7963 19.6949 27.9952 19.8796 28.1594C21.667 29.7482 23.9941 30.5939 26.3847 30.5233C28.7752 30.4527 31.0483 29.4712 32.7389 27.7797L36.5077 24.0125C38.2658 22.2528 39.2537 19.8673 39.2546 17.3799C39.2554 14.8924 38.2692 12.5063 36.5124 10.7453V10.7422Z"
                                    fill={HColor}
                                />
                            </svg>
                            <p className="text-[14px] font-normal text-left" style={{ color: HColor }}>
                                {reviewData?.reviewName
                                    ? reviewData.reviewName
                                    : "Review Name"}
                            </p>
                        </div>
                        {/* </div> */}

                        {/* </div> */}
                    </Link>
                ) : (
                    ""
                )
            )}

        </>
    );
}

export default ReviewCardBasic;